var render = function render(_c,_vm){return _c('div',{staticClass:"b2b-chip",class:{
  [_vm.data.staticClass]: !!_vm.data.staticClass,
  [_vm.data.class]: !!_vm.data.class,
  'b2b-chip--colored': _vm.props.colored,
  'b2b-chip--primary': _vm.props.primary,
  'b2b-chip--small': _vm.props.small,
},style:({
  width: _vm.injections.methods.toSizeValue(_vm.props.width),
  maxWidth: _vm.injections.methods.toSizeValue(_vm.props.maxWidth),
  minWidth: _vm.injections.methods.toSizeValue(_vm.props.minWidth),
  background: _vm.props.background,
  color: _vm.props.color,
})},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.data.domProps && _vm.data.domProps.textContent))]}),(_vm.listeners['click:close'])?_c('span',{staticClass:"b2b-chip__close",on:{"click":function($event){$event.stopPropagation();return _vm.listeners['click:close']($event)}}},[_c(_vm.injections.components.XIcon,{tag:"component"})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }